// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse.attributeTypeMap;
    }
}
SiteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse.discriminator = undefined;
SiteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ScriptsSiteAccountV2PatientsPatientAccountModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=siteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse.js.map